import { useTranslation } from 'react-i18next'
import { useContext, useState } from 'react'
import { motion } from 'framer-motion'
import styles from './ButtonFilter.module.scss'
import ArrowRight from '../Icons/ArrowRight'
import ChevronRight from '../Icons/ChevronRight'
import { Button } from '..'
import FilterFunnel from '../Icons/FilterFunnel'
import getWindowSize from '../../utils/hooks/getWindowSize'
import buttonSound from '../../assets/sounds/fx/14-button.mp3'
import OptionsContext from '../../utils/OptionsContext'
import useSound from 'use-sound'
const ButtonFilter = ({
  filter,
  setFilter,
  JSONsource,
  isCollectionView = false,
  isApp,
}) => {
  const {
    options: { soundEffectsOn, effectsVolume },
  } = useContext(OptionsContext)
  const [playButtonSound] = useSound(buttonSound, { volume: effectsVolume })
  const { t } = useTranslation()
  const [showFilter, setShowFilter] = useState(false)
  const { width } = getWindowSize()

  const categories = [...new Set(JSONsource.flatMap((card) => card.category))]
  const themes = [...new Set(JSONsource.map((obj) => obj.theme))]

  const filters = isCollectionView ? themes : categories

  const DIV = width >= 700 ? 'div' : motion.div

  const duration = 0.2
  const variants = {
    initial: { height: '1px', opacity: 0, y: '-9999px' },
    show: {
      height: 'auto',
      opacity: 1,
      y: 0,
      transition: {
        height: { duration: duration },
        opacity: { delay: duration, duration: duration },
        y: { duration: 0.01 },
      },
    },
    hide: {
      height: '1px',
      opacity: 0,
      y: '-9999px',
      transition: {
        height: { delay: duration, duration: duration },
        opacity: { duration: duration },
        y: { delay: duration * 2 },
      },
    },
  }

  function changeFilter(theme) {
    soundEffectsOn && playButtonSound()
    setFilter(theme)
  }

  function renderTab(theme) {
    const changeAndClose = () => {
      //when in mobile, close menu when choosing:
      if (width <= 700) {
        setShowFilter(!showFilter)
      }
      changeFilter(theme)
    }
    const themeName =
      theme === null
        ? t('common:deckbuilder:categories:all')
        : t(`common:${isCollectionView ? 'theme' : 'category'}:${theme}`)

    const icon = filter === theme ? <ArrowRight /> : <ChevronRight />

    //if app: return buttons instead of inputs (for ripple effect)
    return (
      <>
        {isApp ? (
          <Button
            variant='primary'
            size='small'
            onClick={() => changeAndClose()}
          >
            {themeName}
            {icon}
          </Button>
        ) : (
          <label className={`${filter === theme ? styles.activeLabel : ''}`}>
            <input
              className={`sr-only ${styles.radio}`}
              type='radio'
              name='filter'
              value={themeName}
              onChange={() => changeFilter(theme)}
              checked={filter === theme}
            />
            {themeName}
            {icon}
          </label>
        )}
      </>
    )
  }

  return (
    <fieldset className={styles.wrapper}>
      <legend className='sr-only'>{t('common:buttonFilter')}</legend>
      <div className={styles.filterButtonWrapperMobile}>
        <Button
          variant='primary'
          size='small'
          onClick={() => setShowFilter(!showFilter)}
          aria-expanded={showFilter}
          aria-controls='filter-buttons'
        >
          {t('common:filter')}
          <FilterFunnel />
        </Button>
      </div>

      <DIV
        className={isApp ? styles.filtersWrapperInApp : styles.filtersWrapper}
        variants={variants}
        initial='initial'
        animate={showFilter ? 'show' : 'hide'}
        id='filter-buttons'
      >
        <ul>
          {showFilter ? (
            <>
              <li>{renderTab(null)}</li>
              {filters?.map((filter) => (
                <li key={filter}>{renderTab(filter)}</li>
              ))}
            </>
          ) : (
            ''
          )}
        </ul>
      </DIV>
    </fieldset>
  )
}

export default ButtonFilter
